import { login } from '../sdk/auth.ts'
import { RpcError } from '../sdk/rpc.ts'
import { h } from '../charts/svg.ts'

export function renderLogin(onSuccess: () => void): HTMLElement {
  const email = h('input', { type: 'email', autocomplete: 'username', required: true, id: 'email' })
  const password = h('input', { type: 'password', autocomplete: 'current-password', required: true, id: 'password' })
  const submit = h('button', { class: 'btn btn-primary', type: 'submit', text: 'Sign in' })
  const error = h('div', { class: 'banner banner-critical', hidden: true })

  const form = h(
    'form',
    { class: 'card login-card' },
    h('div', { class: 'brand' }, h('div', { class: 'brand-mark' }), h('h1', { text: 'Irrigation reports' })),
    h('p', { class: 'secondary', style: 'margin:0;font-size:13px', text: 'Sign in with your irrigation.online account.' }),
    error,
    h('div', { class: 'field' }, h('label', { htmlFor: 'email', text: 'Email' }), email),
    h('div', { class: 'field' }, h('label', { htmlFor: 'password', text: 'Password' }), password),
    submit,
  )

  form.addEventListener('submit', async (ev) => {
    ev.preventDefault()
    error.hidden = true
    submit.disabled = true
    submit.textContent = 'Signing in…'
    try {
      await login(email.value.trim(), password.value)
      onSuccess()
    } catch (err) {
      // The proxy throttles logins; show the wait rather than retrying.
      const wait = err instanceof RpcError && err.retryAfter ? ` Try again in ${err.retryAfter}s.` : ''
      error.replaceChildren(
        h('span', { class: 'banner-icon', text: '!' }),
        h('span', { text: `${err instanceof Error ? err.message : String(err)}${wait}` }),
      )
      error.hidden = false
      // A failed sign-in leaves the password field ready for another attempt.
      password.select()
    } finally {
      submit.disabled = false
      submit.textContent = 'Sign in'
    }
  })

  return h('div', { class: 'login-wrap' }, form)
}
